import store from '../state/store';
import { paths } from '../routes';
import { clearPostLoginUtmContent } from './postLoginAttribution';
import { redirect } from './redirect';
import { mixpanel } from '.';
import { MIXPANEL_EVENTS } from '../constants';
import { useStateView } from '../hooks';
import { clearChannelPreferenceCache } from '../service/channelPreferenceCache';
import { clearActiveExperimentAssignments } from '../service/experiments';
import { clearExperimentExposureHistory } from '../service/experimentExposure';
import { selectedReferenceNumberView } from '../state/views';
import { redactUrlForTelemetry } from './telemetryUrl';

export default () => {
  clearChannelPreferenceCache();
  clearActiveExperimentAssignments();
  clearExperimentExposureHistory();

  clearPostLoginUtmContent();

  if (typeof window !== "undefined") {
    try {
      window.sessionStorage.removeItem("paymentFailure:v1");
      window.sessionStorage.removeItem("paymentFailure:v1:plan");
      window.sessionStorage.removeItem("paymentFailure:v1:confirm");
      window.sessionStorage.removeItem("portalPendingLinkedSession");
      Object.keys(window.sessionStorage)
        .filter((key) => key.startsWith("soc-failed-payment-popup:v1"))
        .forEach((key) => window.sessionStorage.removeItem(key));
    } catch (_error) {
      // ignore quota / private mode failures
    }
  }

  // clear state store, don't notify listeners
  // (so we can call this outside of a component)
  store.clear(false);

  mixpanel.track(MIXPANEL_EVENTS.logOut, {
    Location: redactUrlForTelemetry(location.href),
  });
  mixpanel.reset();

  // redirect to login
  redirect(paths.login);
};

